<panel width="400">
	@if (mailTemplate) {
		<h1>{{ mailTemplateHeader }}</h1>
		@if (loading) {
			<skeletons [defaultSkeletons]="4" />
		}
		@else {
			<section>
				<custom-input [label]="'mail-template.title' | translate" [placeholder]="'mail-template.title-placeholder' | translate" [(value)]="mailTemplate.title" [required]="true" />
				@if (missingDefaultTemplates && missingDefaultTemplates.length > 1 && !mailTemplateId) {
				<custom-select [label]="'mail-template.type' | translate" [required]="true" [selectList]="missingDefaultTemplates" [(value)]="mailTemplate.mailTemplateType" />
				}
				<custom-input [label]="'mail-template.subject' | translate" [placeholder]="'mail-template.subject-placeholder' | translate" [(value)]="mailTemplate.subject" />
				<text-group>
					<div>
						<custom-input [label]="'mail-template.use-html' | translate" [inputType]="inputTypeEnum.Switch" [(value)]="useHtml" />
					</div>
					<div class="align-right">
						<tooltip text="{{ 'mail-template.parameters' | translate }}&#10;&#10;{{ mailTemplateParameters }}">
							<icon type="circle-question" small />
						</tooltip>
					</div>
				</text-group>
				@if (useHtml) {
					<custom-input [label]="'mail-template.content' | translate" [inputType]="inputTypeEnum.Editor" [placeholder]="'mail-template.content-placeholder' | translate" [(value)]="mailTemplate.content" />
				}
				@else {
					<custom-input [label]="'mail-template.content' | translate" [inputType]="inputTypeEnum.Textarea" [placeholder]="'mail-template.content-placeholder' | translate" [(value)]="mailTemplate.content" />
				}
			</section>
		}
		<section>
			<button #submitButton (click)="saveMailTemplate()" [label]="'general.save' | translate"></button>
		</section>
	}
</panel>
